var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7196 13.4L20.5196 15.21C20.9819 15.6799 21.1178 16.381 20.8648 16.9896C20.6117 17.5983 20.0188 17.9963 19.3596 18H15.9996V18.34C15.9024 20.4537 14.1136 22.0904 11.9996 22C9.88565 22.0904 8.09688 20.4537 7.99963 18.34V18H4.63963C3.98046 17.9963 3.38757 17.5983 3.13451 16.9896C2.88144 16.381 3.01739 15.6799 3.47963 15.21L5.27963 13.4V8.72999C5.28317 6.79116 6.12147 4.94776 7.58035 3.67076C9.03924 2.39375 10.9774 1.80685 12.8996 2.05999C16.2851 2.57888 18.7691 5.51534 18.7196 8.93999V13.4ZM11.9996 20C13.003 20.0708 13.8844 19.3393 13.9996 18.34V18H9.99963V18.34C10.1148 19.3393 10.9962 20.0708 11.9996 20Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.a6ddf2bec70be05734496f22fd08a92e.svg";
export { ForwardRef as ReactComponent };